import styled from 'styled-components'
import tw from 'twin.macro'

const Heading3 = styled.h3`
  font-family: 'Open Sans';
  ${tw`lg:text-xl font-extrabold`}
`

export { Heading3 }